export const SEARCH_LEN_LIMIT = {
    MIN: 2,
    MAX: 30,
};
